<template>
  <div class="home_header">

    <div class="home_header_content">
      <div class="area" @click="showAreas">
        <span>{{selectedCity.name}}</span>
        <i class="fa fa-angle-down"></i>
      </div>
      <div class="search" @click="gotoSearch">
        <div class="label">关键字</div>
        <!-- <input type="search" placeholder="关键字"> -->
        <button class="search_btn"><i class="fa fa-search"></i></button>
      </div>
      <div class="personal" @click="gotoProfile"><i class="fa fa-user-o"></i></div>
    </div>

    <div class="city_container_wrap" v-show="showCitys">
      <div class="city_container">
        <div class="city">
          <p v-for="(city, index) in citys" :key="index" @click="selectCity(city)">{{city.name}}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getAreaList } from '@/api/activity'
import modalHelper from '@/utils/scroll'

export default {
  name: 'home-header',
  data () {
    return {
      citys: [],
      selectedCity: { id: 0, name: '城市' },
      showCitys: false
    }
  },
  props: {
  },
  mounted () {
  },
  created () {
    this.getAreas()
  },
  methods: {
    async getAreas () {
      let response = await getAreaList()
      this.citys = response.data
      this.citys.unshift({ id: 0, name: '不限' })
    },
    showAreas () {
      if (this.showCitys) {
        modalHelper.beforeClose()
        this.showCitys = false
      } else {
        this.showCitys = true
        modalHelper.afterOpen()
      }
    },
    selectCity (city) {
      modalHelper.beforeClose()
      this.showCitys = false
      this.selectedCity = city
      this.$emit('selectCity', city)
    },
    gotoSearch () {
      this.$router.push('/search')
    },
    gotoProfile () {
      this.$router.push('/user/profile')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";

  .home_header {
    width: 100%;
    height: rem(70);
    .home_header_content {
      max-width: 640px;
      position: fixed;
      z-index: 9999;
      top: 0;
      width: 100%;
      background-color: #fff;
      box-sizing: border-box;
      height: rem(70);
      padding: rem(10) 3%;
      display: flex;
      justify-content: space-between;
      .area {
        font-size: rem(25);
        margin-top: rem(10);
        color: #666;
        width: rem(100);
      }
      .search {
        font-size: rem(20);
        margin-top: rem(15);
        position: relative;
        /*background: url(http://www.feitrip.cn/Public/home/images/searchbg.png);*/
        border-bottom: 1px solid #ff9500;
        width: rem(300);
        background-size: 100% 100%;
        color: #666;
        &:before {
          content:"";
          position:absolute;
          left:0;
          bottom:-1px;
          width:1px;
          height:50%;
          background-color:#ff9500}
        &:after {
          content:"";
          position:absolute;
          right:0;
          bottom:-1px;
          width:1px;
          height:50%;
          background-color:#ff9500
        }
        .label {
          text-align: center;
        }
        input {
          color: #666;
          width: 100%;
          box-sizing: border-box;
          padding: 0 rem(15);
          text-align: center;
        }
        .search_btn {
          font-size: rem(30);
          position: absolute;
          left: rem(25);
          top: rem(-5);
          color: #ff9500;
        }
      }
      .personal {
        font-size: rem(30);
        margin-top: rem(10);
        color: #ff9500;
        width: rem(100);
        text-align: right;
      }
    }
  }

  .city_container {
    width: 100%;
    background-color: #FFFFFF;
    position: fixed;
    top: rem(70);
    z-index: 33333;
    height: 100%;
    overflow: scroll;
    .city {
      width: 90%;
      overflow: hidden;
      padding: rem(35);
      p {
        font-size: rem(30);
        color: #666;
        width: 95%;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #e8ecf1;
      }
    }
  }
</style>
